import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox, NumericTextBox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import SubmitButton from "components/common/SubmitButton";

const EditVat = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (ADD_NEW && !values.vatCodeId) {
      errors.vatCodeId = "VAT Code is required";
    }
    if (!values.details || values.details.trim() === "") {
      errors.details = "Details are required";
    }

    return errors;
  };

  const handleFormSubmit = async (formData) => {
    setSubmitAttempted(true);
    setIsSubmitting(true);
    try {
      await props.onSubmit(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      title={ADD_NEW ? "Add new VAT" : `Edit ${props?.item?.details}`}
      onClose={props.cancelEdit}
      width={600}
    >
      <Form
        onSubmit={handleFormSubmit}
        initialValues={{
          includeInVatReturn: true,
          active: true,
          ...props.item,
        }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <div className="p-3 ps-4">
              <FormElement>
                <fieldset className={"k-form-fieldset"}>
                  {ADD_NEW && (
                    <div className="mb-2">
                      <Label className="label mt-1 mb-2 w-100">
                        VAT Code&nbsp;
                      </Label>
                      <Field
                        name={"vatCodeId"}
                        component={NumericTextBox}
                        spinners={false}
                      />
                      {submitAttempted && formRenderProps.errors.vatCodeId && (
                        <div className="fs-sm my-1 text-danger">
                          <i>{formRenderProps.errors.vatCodeId}</i>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">
                      Details&nbsp;
                    </Label>
                    <Field name={"details"} component={Input} />
                    {submitAttempted && formRenderProps.errors.details && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.details}</i>
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Rate %&nbsp;
                    </Label>
                    <Field
                      name={"rate"}
                      component={NumericTextBox}
                      format="n2"
                      spinners={false}
                      max={99}
                    />
                  </div>
                  <div>
                    <Field
                      name={"includeInVatReturn"}
                      component={Checkbox}
                      defaultChecked={true}
                      label={"Include in VAT Return"}
                    />
                  </div>
                  <div className="mt-2">
                    <Field
                      name={"active"}
                      component={Checkbox}
                      label={"Active"}
                    />
                  </div>
                </fieldset>
              </FormElement>
            </div>
            <div className="dialog-footer">
              <button
                className="bgBtnSecondary common-btn me-2"
                onClick={props.cancelEdit}
              >
                Cancel
              </button>
              <SubmitButton
                className="me-3"
                isLoading={isSubmitting}
                disabled={!formRenderProps.allowSubmit}
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
              >
                {ADD_NEW ? "Save" : "Update"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default EditVat;
